import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import calendar from 'dayjs/plugin/calendar';
import { Typography } from '@mui/material';

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(calendar);

function MessageDate({ createdDate }: { createdDate: string }) {
    const dateLabel = createdDate
        ? dayjs(createdDate).tz(dayjs.tz.guess()).calendar(null, {
              sameDay: '[Today]',
              lastDay: '[Yesterday]',
              lastWeek: 'MM/DD/YY',
              sameElse: 'MM/DD/YY',
          })
        : '';

    return (
        <Typography component="span" variant="body2" color="cement.500">
            {dateLabel}
        </Typography>
    );
}

export default MessageDate;
